import NegativeFeedbackButton from 'app/components/Feedback/NegativeFeedbackButton';
import PositiveFeedbackButton from 'app/components/Feedback/PositiveFeedbackButton';
import useFeedbackAnalytics, {
  FeedbackSentiment,
  FeedbackType,
  UserQueryType,
} from 'app/hooks/fetch/useFeedbackAnalytics';
import useUiConfig from 'app/hooks/useUiConfig';
import { useState, useEffect } from 'react';

export default function TailorSearchFeedbackBanner({
  searchQuery,
  onFeedback,
}: {
  searchQuery?: string;
  onFeedback?: (feedbackSentiment: FeedbackSentiment) => void;
}) {
  const uiConfig = useUiConfig();
  const feedbackQuestion = uiConfig?.feedback?.faqFeedbackQuestion;
  const { captureFeedbackClicked } = useFeedbackAnalytics();
  const [selectedFeedback, setSelectedFeedback] = useState<FeedbackSentiment | undefined>(undefined);

  useEffect(() => {
    setSelectedFeedback(undefined);
  }, [searchQuery]);

  const handleFeedback = (feedbackSentiment: FeedbackSentiment) => {
    if (!searchQuery) return;

    if (selectedFeedback) return;

    setSelectedFeedback(feedbackSentiment);

    captureFeedbackClicked({
      feedbackType: FeedbackType.Search,
      userQuery: searchQuery,
      userQueryType: UserQueryType.Search,
      feedbackSentiment,
    });

    onFeedback?.(feedbackSentiment);
  };

  return (
    <div
      role="region"
      className="py-3 px-4 bg-option flex items-center justify-between"
    >
      <span className="text-sm font-medium text-typography-secondary">{feedbackQuestion}</span>
      <div className="flex items-center gap-3">
        <PositiveFeedbackButton
          onClick={handleFeedback}
          filled={selectedFeedback === FeedbackSentiment.POSITIVE}
        />
        <NegativeFeedbackButton
          onClick={handleFeedback}
          filled={selectedFeedback === FeedbackSentiment.NEGATIVE}
        />
      </div>
    </div>
  );
}
